import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DealNotesHome.html?raw';
import "./DealNotesTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import Button from '../../moreCore/UI/Button/Button';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import DateInput from '../../moreCore/UI/DateInput/DateInput';


class DealNotesHome extends compose(_WidgetBaseSP) {
    templateString: any = template;

    resultTable: MdsLax<InstanceType<typeof StaticTable>>;
    dealNoteDetailsDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    dealNotesContent: HTMLDivElement;
    dealNotesTableContainer: HTMLDivElement;
    dealNotesErrorContainer: HTMLDivElement;

    headerPromoter: string = (this as any).translations["DealNotes_TableHeaderPromoter"];
    headerDocNumber: string = (this as any).translations["DealNotes_TableHeaderDocNumber"];
    headerDate: string = (this as any).translations["DealNotes_TableHeaderDate"];
    headerDealStatus: string = (this as any).translations["DealNotes_TableHeaderDealStatus"];
    headerContractAddress: string = (this as any).translations["DealNotes_TableHeaderContractAddress"];
    headerEmpty: string = "";

    resultTableLayout = {
        "name": "default",
        "label": "Default",
        "attributes": ["ref_address_for_dispatch.gDisp_Name_Firstname", "doc_no", "ref_doc_status_dealnote.description", "doc_date" ],
        "colspans": [1, 1, 1, 1],
        "headings": [(this as any).headerPromoter, (this as any).headerDocNumber, (this as any).headerDealStatus, (this as any).headerDate]
    }

    //table_formatterFunction: Function = lang.hitch(this, function (value: any, header: string, node: HTMLElement, entity: DealNoteObject, rowIndex: number) {
    table_formatterFunction(colEntry: StaticTable.StaticTableCell<any>) {
        
        switch (colEntry.name) {
            // case this.headerDocNumber: // TODO - delete after
            //     if (colEntry.value) {
            //         colEntry.contentnode.innerHTML = colEntry.value;
            //     } else {
            //         colEntry.contentnode.innerHTML = "N.A.";
            //     }
            //     return true;
            //     break;
            // case this.headerEmpty:
            //     var btn = new Button();
            //     btn.setLabel(this.translations["DealNotes_ButtonDetails"]);
            //     btn._onClick_Button = lang.hitch(this, this._onClickDetailsBtn, colEntry.entity, colEntry.tableRow.lineIndex);

            //     btn.placeAt(colEntry.contentnode);
            //     return true;
            //     break;
            default:
                return false;
        }
    }

    private loadAllDealsInfo(): void {
        let requestUrl = window.appRoot + "DealNotes/GetAllDeals";
        this.StandbyStart();

        this.RequestManager.post(
            requestUrl,
            null,
            lang.hitch(this, this._onLoadAllDealsInfoResponse),
            lang.hitch(this, this._onLoadAllDealsInfoError),
            false // sync
        );
    }

    private _onLoadAllDealsInfoResponse(deals: Array<DealNoteObject>): void {
        
        if (this.resultTable != null) {
            this.resultTable.destroy();
            this.dealNotesTableContainer.innerHTML = null;
        }

        this.resultTable = new StaticTable();
        let rowConfig: StaticTable.RowConfig = {
            attributes: this.resultTableLayout.attributes,
            colspans: this.resultTableLayout.colspans,
            headings: this.resultTableLayout.headings,
            colNamesInternal: this.resultTableLayout.headings,
        }

        this.resultTable.setFormatter(this.table_formatterFunction);
        this.resultTable.addLineConfig(rowConfig /*this.resultTableLayout.headings, this.resultTableLayout.colspans, this.resultTableLayout.attributes*/);
        this.UiModder.domConstruct.place(this.resultTable.domNode, this.dealNotesTableContainer)
        this.resultTable.setData(deals);
        this.resultTable.setRowClick(lang.hitch(this, this._onClickDetailsBtn))
        this.resultTable.setCyAttribute("dealNotes");

        this.StandbyStop();
    }

    private _onLoadDealNoteDetailsResponse(deal: DealNoteObject, response: DealNoteDetails): void {

        this.dealNoteDetailsDlg = new GenericDialog();

        this.UiModder.domClass.add(this.dealNotesErrorContainer, "w3-hide");
        this.UiModder.domAttr.set(this.dealNoteDetailsDlg.textNode, "innerHTML", response._tmp_deal_note_details);
                
        this.dealNoteDetailsDlg.destroyOnClose = true;
        this.dealNoteDetailsDlg.set("CancelBtn", true);
        this.dealNoteDetailsDlg.set("header", `${this.translations["DealNotes_DetailsDialogHeader"]}: ${deal.doc_no || "Test-0001"}`);
        this.UiModder.domStyle.set(this.dealNoteDetailsDlg.modalDlgContentNode, "margin", "auto");
        this.UiModder.domStyle.set(this.dealNoteDetailsDlg.textNode, "min-height", "200px");
        //this.UiModder.domStyle.set(this.dealNoteDetailsDlg.textNode, "max-height", "600px");

        let confirmedByPerformerCB = new CheckBox();
        confirmedByPerformerCB.setValue(deal.is_approved_by_performer);
        confirmedByPerformerCB.setLabel(this.translations["DealNotes_DetailsDialogCheckboxLabel"]);
        confirmedByPerformerCB.setReadonly(true);
        //this.UiModder.domClass.add(confirmedByPerformerCB.inputContainer, "w3-margin-right"); // nicht merhr unterstütz - RJ 2023-03
        //this.UiModder.domClass.add(confirmedByPerformerCB.domNode, "w3-padding-small");

        let LeftSubNode = this.UiModder.domConstruct.create("div", { class: "w3-threequarter flex_row w3-margin-bottom" }, this.dealNoteDetailsDlg.bottomSubTitleNode);
        let RightSubNode = this.UiModder.domConstruct.create("div", { class: "w3-threequarter flex_row" }, this.dealNoteDetailsDlg.bottomSubTitleNode);

        this.dealNoteDetailsDlg.hideSubtitleNode(false, true);
        //this.UiModder.domClass.add(this.dealNoteDetailsDlg.bottomSubTitleNode, "w3-medium flex_row");

        let confirmBtn = new Button();
        confirmBtn.setLabel(this.translations["DealNotes_DetailsDialogButtonLabel"]);
        confirmBtn._onClick_Button = lang.hitch(this, this._onClickConfirmBtn, deal);
        confirmBtn.setClasses("w3-padding w3-margin-right");

        confirmBtn.placeAt(LeftSubNode);
        confirmedByPerformerCB.placeAt(LeftSubNode);

        if (deal.is_approved_by_performer === true) {
            confirmBtn.hide();

            let confirmationDate = new DateInput();

            confirmationDate.setValue(deal.date_approved_by_performer);
            confirmationDate.setLabel(this.translations["DealNotes_DetailsDialogConfirmationDateLabel"]);
            this.UiModder.domClass.add(confirmationDate.labelNode, "w3-right w3-padding-small");
            //this.UiModder.domClass.add(confirmationDate.domNode, "w3-padding-left");
            confirmationDate.setReadonly(true);
            
            confirmationDate.placeAt(LeftSubNode);
        }

        let consultationBtn = new Button();
        consultationBtn.setLabel(this.translations["DealNotes_DetailsDialogConsultationButtonLabel"]);
        consultationBtn._onClick_Button = lang.hitch(this, this._onClickConsultationBtn, deal);

        consultationBtn.setClasses("w3-padding");

        consultationBtn.placeAt(RightSubNode);

        if (response.ref_doc_status_dealnote != null && response.ref_doc_status_dealnote.is_to_publish_in_app === true) {

            this.UiModder.domConstruct.create("label", {
                class: "w3-padding-small w3-margin-left w3-large",
                innerHTML: "Status:"
            }, RightSubNode);

            this.UiModder.domConstruct.create("input", {
                type: "text",
                class: "w3-input w3-border w3-third",
                style: `background-color:${response.ref_doc_status_dealnote.coloration.BackColor.Hex}; color:${response.ref_doc_status_dealnote.coloration.TextColor.Hex};`,
                value: response.ref_doc_status_dealnote.description,
                readonly: ""
            }, RightSubNode);
        }

        if (response.isConsultationRequested === true) {
            consultationBtn.setClassesEx({ enabledClasses: "secondaryBG mds-hover-bright w3-padding", disabledClasses: "w3-disabled w3-padding" });
            consultationBtn.setReadonly(true);
            confirmBtn.setClassesEx({ enabledClasses: "secondaryBG mds-hover-bright w3-padding", disabledClasses: "w3-disabled w3-padding" });
            confirmBtn.setReadonly(true);
        };
        if (deal.is_approved_by_performer === true) {
            consultationBtn.setClassesEx({ enabledClasses: "secondaryBG mds-hover-bright w3-padding", disabledClasses: "w3-disabled w3-padding" });
            consultationBtn.setReadonly(true);
        }
        
        this.dealNoteDetailsDlg.show();

        this.StandbyStop();
    }

    private _onApproveDealNoteResponse() {
        let approveDlg = new GenericDialog();

        this.UiModder.domAttr.set(approveDlg.textNode, "innerHTML", "<h5>" + this.translations["DealNotes_ApprovedDialogMessage"] + "</h5>");

        approveDlg.destroyOnClose = true;
        approveDlg.set("CancelBtn", true);
        approveDlg.set("header", this.translations["DealNotes_ApprovedDialogHeader"]);
        this.UiModder.domStyle.set(approveDlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(approveDlg.modalDlgContentNode, "margin-top", "100px");
        this.UiModder.domClass.add(approveDlg.modalDlgContentNode, "w3-round");
        this.UiModder.domStyle.set(approveDlg.textNode, "min-height", "150px");
        //this.UiModder.domClass.replace(approveDlg.headerBarNode, "mds-bg-orange", "secondaryBG");
        this.UiModder.domClass.add(approveDlg.textNode, "w3-padding-64 w3-container w3-center");

        approveDlg.show();

        this.loadAllDealsInfo();
    }

    _onConsultationRequiredResponse() {
        let approveDlg = new GenericDialog();

        this.UiModder.domAttr.set(approveDlg.textNode, "innerHTML", "<h5>" + this.translations["DealNotes_ConsultationRequestDialogMessage"] + "</h5>");

        approveDlg.destroyOnClose = true;
        approveDlg.set("CancelBtn", true);
        approveDlg.set("header", this.translations["DealNotes_ConsultationRequestDialogHeader"]);
        this.UiModder.domStyle.set(approveDlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(approveDlg.modalDlgContentNode, "margin-top", "100px");
        this.UiModder.domClass.add(approveDlg.modalDlgContentNode, "w3-round");
        this.UiModder.domStyle.set(approveDlg.textNode, "min-height", "150px");
        //this.UiModder.domClass.replace(approveDlg.headerBarNode, "mds-bg-orange", "secondaryBG");
        this.UiModder.domClass.add(approveDlg.textNode, "w3-padding-64 w3-container w3-center");

        approveDlg.show();

        this.loadAllDealsInfo();
    }

    private _onLoadAllDealsInfoError(err: any): void {

        this.UiModder.domClass.remove(this.dealNotesErrorContainer, "w3-hide");
        this.UiModder.domAttr.set(this.dealNotesErrorContainer, "innerHTML", err.Message);
        this.StandbyStop();
    }

    _onClickDetailsBtn(row: StaticTable.StaticTableRow<any>): void {
        let deal = row.entity;

        this.StandbyStart(this.dealNotesTableContainer);

        this.RequestManager.post(
            window.appRoot + "DealNotes/GetDealNoteDetails",
            { "dealID": deal.ID },
            lang.hitch(this, this._onLoadDealNoteDetailsResponse, deal ),
            lang.hitch(this, function (err: any) {
                this.UiModder.domClass.remove(this.dealNotesErrorContainer, "w3-hide");
                this.UiModder.domAttr.set(this.dealNotesErrorContainer, "innerHTML", err.Message);
            }),
            false // sync
        );        
    }

    _onClickConfirmBtn(deal: DealNoteObject): void {
        this.StandbyStart();

        this.RequestManager.post(
            window.appRoot + "DealNotes/ConfirmDealNote",
            { "dealID": deal.ID },
            lang.hitch(this, this._onApproveDealNoteResponse),
            lang.hitch(this, function (err: any) {
                console.error("ERROR: ", err);
                if (typeof err === "string") {
                    alert("ERROR: " + err);
                } else if (err["Message"]) {
                    alert("ERROR: " + err["Message"]);
                } else {
                    alert("ERROR. Please check the console");
                }
            }),
            false // sync
        );
        this.dealNoteDetailsDlg.close();
    }

    _onClickConsultationBtn(deal: DealNoteObject): void {
        this.StandbyStart();

        this.RequestManager.post(
            window.appRoot + "DealNotes/ConsultationRequired",
            { "dealID": deal.ID },
            lang.hitch(this, this._onConsultationRequiredResponse),
            lang.hitch(this, function (err: any) {
                console.error("ERROR: ", err);
                if (typeof err === "string") {
                    alert("ERROR: " + err);
                } else if (err["Message"]) {
                    alert("ERROR: " + err["Message"]);
                } else {
                    alert("ERROR. Please check the console");
                }
            }),
            false // sync
        );
        this.dealNoteDetailsDlg.close();
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.loadAllDealsInfo();
    }
}

export default mdsWidget(DealNotesHome);